var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: { option: _vm.option, data: _vm.copyList },
              on: {
                "refresh-change": _vm.refreshChange,
                "selection-change": _vm.selectionChange,
                select: _vm.select,
                "select-all": _vm.selectAll,
              },
              scopedSlots: _vm._u([
                {
                  key: "name",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          !scope.row.isEdit
                            ? _c(
                                "div",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOpenEdit(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.name) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          scope.row.isEdit
                            ? _c("el-input", {
                                class: "input-" + scope.row.id,
                                staticStyle: { width: "100px" },
                                attrs: {
                                  placeholder: scope.row.name,
                                  size: "mini",
                                  disabled: scope.row.isLoading,
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.handleBlur(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.value,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "value", $$v)
                                  },
                                  expression: "scope.row.value",
                                },
                              })
                            : _vm._e(),
                          scope.row.isEdit
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "margin-left": "10px",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "primary",
                                        loading: scope.row.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.saveEdit(scope.row, $event)
                                        },
                                      },
                                    },
                                    [_vm._v("保存")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          scope.row.isEdit = false
                                        },
                                      },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "menu",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "STORAGE_MANAGE_COPY_LINK",
                              expression: "'STORAGE_MANAGE_COPY_LINK'",
                            },
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:copy",
                              value: row.playUrl,
                              expression: "row.playUrl",
                              arg: "copy",
                            },
                          ],
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.copyLink },
                        },
                        [_vm._v("复制链接")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "STORAGE_MANAGE_PREVIEW",
                              expression: "'STORAGE_MANAGE_PREVIEW'",
                            },
                          ],
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handlePreview(row.playUrl)
                            },
                          },
                        },
                        [_vm._v("预览")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "STORAGE_MANAGE_DEL",
                              expression: "'STORAGE_MANAGE_DEL'",
                            },
                          ],
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleDelete(row.id)
                            },
                          },
                        },
                        [_vm._v("\n          删除\n        ")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "mySearch" }, [
                _c("div", { staticClass: "search-contain" }, [
                  _c("div", { staticClass: "search-left" }, [
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          staticStyle: {
                            width: "200px !important",
                            "margin-right": "10px",
                          },
                          attrs: { clearable: "", placeholder: "文件名称" },
                          model: {
                            value: _vm.searchParams.search,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchParams, "search", $$v)
                            },
                            expression: "searchParams.search",
                          },
                        }),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "200px !important",
                              "margin-right": "10px",
                            },
                            attrs: { placeholder: "状态", clearable: "" },
                            model: {
                              value: _vm.searchParams.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchParams, "status", $$v)
                              },
                              expression: "searchParams.status",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "待上传", value: "0" },
                            }),
                            _c("el-option", {
                              attrs: { label: "上传中", value: "1" },
                            }),
                            _c("el-option", {
                              attrs: { label: "上传完成", value: "2" },
                            }),
                            _c("el-option", {
                              attrs: { label: "上传失败", value: "3" },
                            }),
                            _c("el-option", {
                              attrs: { label: "转码中", value: "4" },
                            }),
                            _c("el-option", {
                              attrs: { label: "转码完成", value: "5" },
                            }),
                            _c("el-option", {
                              attrs: { label: "转码失败", value: "6" },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "200px !important",
                              "margin-right": "10px",
                            },
                            attrs: { placeholder: "转码分组", clearable: "" },
                            model: {
                              value: _vm.searchParams.aliyunTemplateId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchParams,
                                  "aliyunTemplateId",
                                  $$v
                                )
                              },
                              expression: "searchParams.aliyunTemplateId",
                            },
                          },
                          _vm._l(_vm.templateGroup, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "200px !important",
                              "margin-right": "10px",
                            },
                            attrs: { placeholder: "批量处理", clearable: "" },
                            model: {
                              value: _vm.searchParams.options,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchParams, "options", $$v)
                              },
                              expression: "searchParams.options",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "批量复制链接", value: "1" },
                            }),
                            _c("el-option", {
                              attrs: { label: "批量删除", value: "2" },
                            }),
                            _c("el-option", {
                              attrs: { label: "批量下载", value: "3" },
                            }),
                          ],
                          1
                        ),
                        _c("div", {
                          staticStyle: {
                            display: "block",
                            width: "200px !important",
                            "margin-right": "10px",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "STORAGE_MANAGE_SEARCH",
                                expression: "'STORAGE_MANAGE_SEARCH'",
                              },
                            ],
                            staticStyle: { "margin-right": "0.5%" },
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.search },
                          },
                          [_vm._v("搜 索")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "STORAGE_MANAGE_ADD_FILE",
                                expression: "'STORAGE_MANAGE_ADD_FILE'",
                              },
                            ],
                            staticStyle: { "margin-right": "0.5%" },
                            attrs: { size: "small" },
                            on: { click: _vm.handleAdd },
                          },
                          [_vm._v("添加文件")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", {
                    staticClass: "search-left",
                    staticStyle: { "margin-top": "10px" },
                  }),
                ]),
              ]),
            ],
            2
          ),
          _c("ElementPagination", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              "current-page": _vm.searchParams.current,
              "page-size": _vm.searchParams.size,
              total: _vm.searchParams.total,
              "page-sizes": [10, 20, 30, 40, 50, 100],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("AddDialog", {
        ref: "addDialog",
        attrs: { params: _vm.params },
        on: {
          refresh: () => {
            _vm.loadList()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }